import { Spinner as DigdirSpinner, } from "@digdir/designsystemet-react";
const Spinner = DigdirSpinner;
Spinner.displayName = "Spinner";
export { Spinner };
//# sourceMappingURL=spinner.js.map